document.addEventListener('DOMContentLoaded', function() {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.badge-lazyload').forEach(badge => {
      badge.classList.add('loaded');
    });
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const badge = entry.target;
        badge.classList.add('loaded');
        observer.unobserve(badge);
      }
    });
  }, {
    rootMargin: '100px 0px',
    threshold: 0.1
  });

  document.querySelectorAll('.badge-lazyload').forEach(badge => {
    observer.observe(badge);
  });
});
